import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import * as DOMPurify from 'dompurify';
import Axios from 'axios';
import { domain } from '../env';

export const ScarsvEn = () => {
    const [scarsvall, setScarsvall] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const getScarsv = async () => {
        setLoading(true);
        try {
            const response = await Axios({
                method: "get",
                url: `${domain}/api/scarsv/?page=1`
            });
            // Make sure we're handling the paginated response properly
            const data = response.data && response.data.results ? response.data.results : [];
            setScarsvall(data);
            setLoading(false);
            console.log(data, "scarsv data");
        } catch (err) {
            console.error("Error fetching scarsv:", err);
            setError("Failed to load data");
            setLoading(false);
            // Initialize with empty array to prevent map() errors
            setScarsvall([]);
        }
    };

    useEffect(() => {
        getScarsv();
    }, []);

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div>
        );
    }

    if (error) {
        return <div className="text-center py-5">Error: {error}</div>;
    }

    return (
        <>
            <section className="news-one">
                <div className="container">
                    <div className="section-title text-center">
                        <span className="section-title__tagline">Latest Activities</span>
                        <h2 className="section-title__title">Latest Activities & News</h2>
                    </div>
                    <div className="row">
                        {Array.isArray(scarsvall) && scarsvall.length > 0 ? (
                            scarsvall.slice(0, 3).map((sc) => (
                                <div className="col-xl-4 col-lg-4 wow fadeInUp" data-wow-delay="100ms" key={sc?.id}>
                                    <div className="news-one__single">
                                        <div className="news-one__img">
                                            <LazyLoadImage
                                                effect="blur"
                                                src={`${domain}${sc?.image}`}
                                                alt={sc?.title_english || "Activity Image"}
                                                width="100%"
                                                height="250px"
                                                threshold={100}
                                                placeholder={<div className="loading-placeholder"></div>}
                                            />
                                            <div className="news-one__date">
                                                <p>{sc?.createdat}</p>
                                            </div>
                                            <a href={`/scarsvdetails${sc?.id}`}>
                                                <span className="news-one__plus"></span>
                                            </a>
                                        </div>
                                        <div className="news-one__content">
                                            <ul className="list-unstyled news-one__meta">
                                                <li><a href="#!"><i className="far fa-user-circle"></i> YOUTH PLANET</a></li>
                                            </ul>
                                            <h3 className="news-one__title">
                                                <a href={`/scarsvdetails${sc?.id}`}>{sc?.title_english}</a>
                                            </h3>
                                            <p className="news-one__text" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(`${sc?.details_English?.slice(0, 100)}...`) }} />
                                            <div className="news-one__read-more">
                                                <a href={`/scarsvdetails${sc?.id}`}>Read More <i className="fas fa-angle-double-right"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="col-12 text-center">
                                <p>No activities found</p>
                            </div>
                        )}
                    </div>
                    <div className="all-blog-btn text-center" style={{ marginBottom: '30px' }}>
                        <a href="/scarsv" className="thm-btn all-blog-btn__btn">All Activities</a>
                    </div>
                </div>
            </section>
        </>
    );
};
